const config = {
  NAME: 'Salud',
  PATH: '/salud',
};

export default config;
